import styled from 'styled-components'
import {deviceMax} from '../../theme/breakpoints'
import pxToRem from '../../utils/pxToRem'
import Button from '../Button/Button'
import ArrowRight from '../../images/icons/arrow-right-tile.svg'

export const Container = styled.div`
  width: 100%;
`

export const StyledNewsHeader = styled.div`
  justify-content: space-between;
  align-items: center;
  display: flex;
  margin-bottom: ${pxToRem(20)};
  width: 100%;
  @media ${deviceMax.mobileL} {
    gap: ${pxToRem(20)};
    flex-direction: column;
    align-items: flex-start;
    padding: ${pxToRem(10)};
  }
`

export const StyledHeaderContainer = styled.div`
  align-items: center;
  display: flex;
  gap: ${pxToRem(40)};
  @media ${deviceMax.mobileL} {
    width: 100%;
    justify-content: space-between;
    gap: initial;
  }
`

export const Subscribe = styled.p`
  cursor: pointer;
  font-weight: ${({theme}) => theme.fonts.weight.bold};
  font-size: ${({theme}) => theme.fonts.sizes.button};
  line-height: ${({theme}) => theme.fonts.lineHeight.button};
`
export const NewsContainer = styled.div`
  flex-direction: column;
  display: flex;
  @media ${deviceMax.mobileL} {
    flex-direction: row;
    width: 100%;
    overflow: auto;
    margin-bottom: ${pxToRem(10)};
    ::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
  }
`
